<!-- <ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>

  </ion-toolbar>
</ion-header> -->

<ion-content [fullscreen]="true">
<ion-grid>
  <!-- <ion-row style="padding-top: 15px;">
    <ion-col>&nbsp;</ion-col>
  </ion-row> -->
  <!-- <app-header></app-header> -->
  <ion-row>
    <ion-col size-xs="12" size-sm="6" size-md="4" size-lg="4" size-xl="3">
      <ion-card class="card-container">
        <ion-grid style="padding: 0 0 0 0;">
          <ion-row class="title">
            <ion-col >
              <label>Il mio oro</label>
            </ion-col>
          </ion-row>
          <ion-row class="margin-middle-row">
            <ion-col>
            </ion-col>
          </ion-row>

          <ion-row style="padding-left: 10px; ">
            <ion-col >
              <span style="font-size: 1.5rem; font-weight: 600; ">
                <span style="color:black; ">Totale grammi </span>
                <br><span style="font-size: 1.4rem; color: #835F08;">{{grTotalGold | number : '1.2-2'}} gr</span>
              </span>
            </ion-col>
          </ion-row>
          <ion-row class="row-valore-attuale" style="padding-left: 10px; ">
            <ion-col>
              <span class="label-piechart-bottom" style="color: black; font-size:1.5rem; font-weight: 600;">Valore attuale </span>
              <br>&nbsp;<span class="label-bottom-gold" style="color: #835F08; font-size: 1.6rem;">{{totalBalanceTotWallet|currency:'EUR'}}</span>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-card>    
    </ion-col>


    <ion-col size-xs="12" size-sm="6" size-md="4" size-lg="4" size-xl="3">

      <ion-card class="card-container">
        <ion-grid style="padding: 0 0 0 0;">
          <ion-row class="title">
            <ion-col >
              <label>Rivalutazione </label>
            </ion-col>
          </ion-row>
          <ion-row class="margin-middle-row">
            <ion-col>

            </ion-col>
          </ion-row>

            <ion-row style="padding-left: 10px; ">
              <ion-col >
                <span style="font-size: 1.5rem; font-weight: 600; ">
                  <span style="color:black; ">Rivalutazione</span>
                  <br>
                  <!-- <span class="gold legend-font" style="color:835F08; font-size:1.5 rem" [class.gold]="revaluateDepositPie.result[1].value>=0" [class.red]="revaluateDepositPie.result[1].value<0">{{revaluateDepositPie.result[1].value}} %</span>   -->
                  <span style="color:#835F08; font-size:1.5 rem" >{{revaluateDepositPie.result[1].value}} %</span>  
                </span>
              </ion-col>
            </ion-row>
            <!-- <ion-row class="row-valore-attuale" style="padding-left: 10px; ">
              <ion-col>
                <span class="gold legend-font" style="color:835F08; font-size:1.5 rem" [class.gold]="revaluateDepositPie.result[1].value>=0" [class.red]="revaluateDepositPie.result[1].value<0">{{revaluateDepositPie.result[1].value}} %</span>
              </ion-col>
            </ion-row> -->

            
        </ion-grid>
      </ion-card>
    </ion-col>

    <ion-col size-xs="12" size-sm="6" size-md="4" size-lg="4" size-xl="3" >
      <ion-card class="card-container">
        <ion-grid style="padding: 0 0 0 0;">
          <ion-row class="title">
            <ion-col >
              <label>Piano Acquisto ORO (PAC) </label>
            </ion-col>
          </ion-row>
          <ion-row class="margin-middle-row">
            <ion-col>

            </ion-col>
          </ion-row>

          <ion-row class="row-valore-attuale">
            <ion-col>
              <div class="buy-plan-gold">
                <span class="legend-font-pac">PAC 100 &nbsp;&nbsp;&nbsp;&nbsp;<span style="color: #835F08;">{{goldBuyPlan!.PAO100}}%</span></span><BR>
                <span class="legend-font-pac">PAC 250  &nbsp;&nbsp;&nbsp;&nbsp;<span style="color:835F08;">{{goldBuyPlan!.PAO250}}%</span></span><BR>
                <span class="legend-font-pac">PAC 500  &nbsp;&nbsp;&nbsp;&nbsp;<span style="color:835F08;">{{goldBuyPlan!.PAO500}}%</span></span><BR>
                <span class="legend-font-pac">PAC 1000  &nbsp;&nbsp;<span style="color:835F08;">{{goldBuyPlan!.PAO1000}}%</span></span><BR>
              </div>           
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-card>

      <!-- <app-pie-chart [pieChartData]="goldBuyPlan" *ngIf="!!goldBuyPlan"> -->

        <!-- <div bottom>
          <span class="label-piechart-bottom">Valore oro: </span>
          <span class="label-bottom-gold">{{goldBuyPlan.TotBalanceGrGold}} gr. ORO</span>
        </div> -->
      <!-- </app-pie-chart> -->
    </ion-col>

    <ion-col size-xs="12" size-sm="6" size-md="4" size-lg="4" size-xl="3" >

      <ion-card class="card-container">
        <ion-grid style="padding: 0 0 0 0;">
          <ion-row class="title">
            <ion-col >
              <label>Conto ORO</label>
            </ion-col>
          </ion-row>

      <ion-row class="margin-middle-row">
        <ion-col></ion-col>
      </ion-row>
      <ion-row style="padding-left: 10px; " >
        <ion-col >
          <span style="font-size: 1.5rem; font-weight: 600; ">
            
            <span *ngIf="!isAdmin" style="color:black; ">Totale grammi </span>
            <span *ngIf="isAdmin" style="color:black; ">Grammi aziendali </span>
            <br><span style="font-size: 1.4rem; color: #835F08;">{{grContoOro | number : '1.2-2'}} gr</span>
          </span>
        </ion-col>

      </ion-row>
      <ion-row class="row-valore-attuale" style="padding-left: 10px; ">
        <ion-col *ngIf="!isAdmin">
          <span class="label-piechart-bottom" style="color: black; font-size: 1.5rem; font-weight: 600;">Valore attuale </span>
          <br>&nbsp;<span class="label-bottom-gold" style="color: #835F08; font-size: 1.6rem;">€ {{((grContoOro*goldValue) | number:'1.2-2') }} </span>
        </ion-col>
        <ion-col *ngIf="isAdmin">
          <span class="label-piechart-bottom" style="color: black font-size: 1.5rem; font-weight: 600;">Oro utenti </span>
          <br>&nbsp;<span class="label-bottom-gold" style="color: #835F08; font-size: 1.6rem;">{{(grContoOroUtenti ) | number : '1.2-2'}} gr</span>
        </ion-col>

      </ion-row>


      </ion-grid>
    </ion-card>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size-xs="12" size-sm="12" size-md="9" size-lg="9" size-xl="9" >
      <ion-card class="card-container2" >
        <!-- <app-tradingview></app-tradingview>         -->
        <app-lazy-loading-chart-component></app-lazy-loading-chart-component>
      </ion-card>
    </ion-col>
    <ion-col size-xs="12" size-sm="12" size-md="4" size-lg="4" size-xl="3" >

      <ion-card class="card-container2">
        <ion-grid style="height: 100%; padding: 0 0 0 0;">
          <ion-row class="title">
            <ion-col >
              <label>Alert</label>
            </ion-col>
          </ion-row>
      <ion-row class="magin-div">
        <ion-col>

        </ion-col>
      </ion-row>
      <ion-row  style="height: 50%; align-content: end;">
        <ion-col size="12">
          <ion-label style="font-size: 2 rem; font-weight: 600; color:#835F08; ">VENDO</ion-label>
        </ion-col>

          <ion-col size="1">
              <ion-checkbox style="--border-color: black; --checkbox-background-checked: #838383" [(ngModel)]="alertIsActiveSell" (ionChange)="saveSogliaSell()">

              </ion-checkbox>
          </ion-col>
          <ion-col size="11">
            <ion-label  style="font-size: 2 rem; font-weight: 600; color:black; ">Voglio VENDERE quando l'oro vale:</ion-label>
              <ion-item  class="input-item-alert" lines="none">

                  <input  #alertamountSell
                          style="padding:0px; border: 0px;"
                            type="number"
                            [disabled]="!alertIsActiveSell"
                            [(ngModel)]="sogliaSell"
                            (focus)= "inputIsOnFocusSell = true"
                             (blur) = "inputIsOnFocusSell = false; onValueChangeSell()"
                            (change)="sogliaSell = sogliaSell<=0?goldValue:sogliaSell; saveSogliaSell()"
                            step="1"
                            min="0"/>
                            <span slot="end" style="padding-right:3px">€/Gr</span>

                  <div class="navigator">
                      <div class="square" (click)="addSell()">
                          <ion-icon name="chevron-up-outline"></ion-icon>
                      </div>
                      <div class="square" (click)="removeSell()">
                          <ion-icon name="chevron-down-outline"></ion-icon>
                      </div>
                  </div>
              </ion-item>
          </ion-col>
          <ion-col size="12">
            
          </ion-col>
          <ion-col size="12">
            <ion-label style="font-size: 2 rem; font-weight: 600; color:#835F08; ">ACQUISTO</ion-label>
          </ion-col>
          <ion-col size="1">
            <ion-checkbox  style="--border-color: black; --checkbox-background-checked: #838383" [(ngModel)]="alertIsActive" (ionChange)="saveSoglia()">

            </ion-checkbox>
        </ion-col>
          <ion-col size="11">
            <ion-label style="font-size: 2 rem; font-weight: 600; color:black; ">Voglio ACQUISTARE quando l'oro vale:</ion-label>
              <ion-item  class="input-item-alert" lines="none">

                  <input  #alertamount
                          style="padding:0px; border: 0px;"
                            type="number"
                            [disabled]="!alertIsActive"
                            [(ngModel)]="soglia"
                            (focus)= "inputIsOnFocus = true"
                             (blur) = "inputIsOnFocus = false; onValueChange()"
                            (change)="soglia = soglia<0?goldValue:soglia; saveSoglia()"
                            step="1"
                            min="0"/>
                            <span slot="end" style="padding-right:3px">€/Gr</span>

                  <div class="navigator">
                      <div class="square" (click)="add()">
                          <ion-icon name="chevron-up-outline"></ion-icon>
                      </div>
                      <div class="square" (click)="remove()">
                          <ion-icon name="chevron-down-outline"></ion-icon>
                      </div>
                  </div>
              </ion-item>
          </ion-col>
        </ion-row>

          <ion-row class="magin-div">
            <ion-col>

            </ion-col>
          </ion-row>
          <!-- <ion-row class="row-valore-attuale" style="height: 100% !important; align-items: center;">
            <ion-col size="12" class="full-height">
            <!-- <ion-button  class="prezzo btn" style="--background: none">

              <span ><b>Analizza andamento oro</b></span>
            </ion-button>
             </ion-col>
          </ion-row> -->


      </ion-grid>
    </ion-card>
    </ion-col>
  <!-- alert prezzo per mobile -->
  </ion-row>

</ion-grid>
</ion-content>
